import React, { useState, useEffect } from "react";
import SideBar from "./SideBar";
import Header from "./Header";
import { SlHome } from "react-icons/sl";
import { SlArrowRight } from "react-icons/sl";
import { useLocation } from 'react-router-dom';
import { FaEdit } from "react-icons/fa";
import { FaMinusCircle } from "react-icons/fa";
import { MdDeleteOutline } from "react-icons/md";
import { createNewCategory, deleteCategory, getCategorySubMenusAPI, referralUserOrderDetails } from '../../serverApi/server'

const ReferralUsers = () => {
  const location = useLocation();
  const agentsList = location.state || [];
  const [referralUserList, setReferralUserList] = useState([])
  const [selectedAgent, setSelectedAgent] = useState(
    agentsList[0].user
  );
  
  const handleCategoryChange = (e) => {
    setSelectedAgent(e.target.value);
  };

  const fetchAgentsUser = async () => {
    try {
      if (selectedAgent) {
        const referralUserOrderDetailsAPIResponse = await referralUserOrderDetails(selectedAgent);
        setReferralUserList(referralUserOrderDetailsAPIResponse.data.referral_agent_user)
      }
    } catch (error) {
      console.error('Error fetching sub-menus:', error);
    }
  };

  useEffect(() => {
    if (selectedAgent) {
      fetchAgentsUser();
    }
  }, [selectedAgent]);

  return (
    <div className="flex w-full h-screen">
      <div className="fixed h-full custom-scroll">
        <SideBar />
      </div>
      <div className="ml-64 flex-1 overflow-y-auto">
        <Header />
        <div className="bg-[#F5F7FD] px-7 py-6">
          <div className="flex items-center justify-between">
            <div className="text-blue-950 flex items-center gap-6">
              <h1 className="pr-6 text-2xl font-medium border-r">
                Admin Users
              </h1>
              <div className="flex text-sm items-center gap-3">
                <button>
                  <SlHome />
                </button>
                <SlArrowRight />
                <button>
                  Referral
                </button>
                <SlArrowRight />
                <button>
                  View Referral User
                </button>
              </div>
            </div>
          </div>

          <div className='bg-white mt-10 px-3 py-4 rounded-lg'>
            <div className='flex items-center gap-3 text-sm'>
              <p className='text-neutral-500'>Filter by Agents:</p>
              <div className='flex items-center gap-2'>
                <select className='focus:outline-none focus:border-blue-300 border rounded px-1 py-1'
                  onChange={handleCategoryChange}
                  value={selectedAgent}
                >
                  {agentsList.map((agents) => (
                    <option key={agents.user} value={agents.user}>
                      {agents.full_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="overflow-x-auto table-auto">
              <table className="min-w-full bg-white mt-8" style={{ borderCollapse: 'separate', borderSpacing: '2px' }}>
                <thead>
                  <tr>
                    <th className="px-2 text-start whitespace-nowrap py-2 border border-[#48ABF7] text-white font-normal bg-blue-400" style={{ width: '1%' }}>CUSTOMER<br/>NAME</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">AGENT<br/>NAME</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">REFERRAL<br/>CODE</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">CUSTOMER<br/>DISCOUNT %</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">CUSTOMER<br/>DISCOUNT<br/>AMOUNT</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">AGENT<br/>DISCOUNT %</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">AGENT<br/>DISCOUNT<br/>AMOUNT</th>
                    <th className="px-2 sm:px-4 text-start py-2 border border-[#48ABF7] text-white font-normal bg-blue-400">PRODUCT<br/>AMOUNT</th>
                  </tr>
                </thead>
                <tbody>
                  {referralUserList.length > 0 ? (
                      referralUserList.map((referralUser) => (
                      <tr key={referralUser.id}>
                        <td className="px-4 py-2 border border-[#48ABF7]">{referralUser.customer_name}</td>
                        <td className="px-4 py-2 border border-[#48ABF7]">{referralUser.agent_name}</td>
                        <td className="px-4 py-2 border border-[#48ABF7]">{referralUser.agent_referral_code}</td>
                        <td className="px-4 py-2 border border-[#48ABF7]">{referralUser.customer_discount} %</td>
                        <td className="px-4 py-2 border border-[#48ABF7]">{parseFloat(referralUser.customer_discount_amount).toFixed(2)}</td>
                        <td className="px-4 py-2 border border-[#48ABF7]">{referralUser.agent_discount} %</td>
                        <td className="px-4 py-2 border border-[#48ABF7]">{parseFloat(referralUser.agent_discount_amount).toFixed(2)}</td>
                        <td className="px-4 py-2 border border-[#48ABF7]">{parseFloat(referralUser.total_amount).toFixed(2)}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="5" className="px-4 py-6 text-center text-neutral-600">
                        No users available.
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReferralUsers;

